import React from 'react';
import classNames from 'classnames';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';
import Duration from 'main/components/show/cuesheet/duration';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const SimpleDurationCell = (props) => {
  const {
    item,
    user,
    isSelected,
    displayDuration,
    durationDisplayType,
  } = props;

  const userId = user.get('_id');

  const wrapperClasses = classNames(
    'cs-simple-cell-wrapper',
    HighlightCellHelper.getPersonalHighlightClass(item, userId),
  );

  const cellClasses = classNames('cs-cell cs-data-cell', {
    'cs-cell-selected': isSelected,
  });

  return (
    <div
      className={wrapperClasses}
      style={HighlightCellHelper.getPersonalHighlightStyle(item, userId)}
    >
      <div
        style={HighlightCellHelper.getGlobalHighlightStyle(item)}
        className={cellClasses}
      >
        <Duration
          displayDuration={displayDuration}
          durationDisplayType={durationDisplayType}
          showRunTimeSuppressionToggle
          isSelected={isSelected}
          value={item.get('durationInSeconds')}
          simple
          {...props}
        />
      </div>
    </div>
  );
};

export default SimpleDurationCell;
